import { CollectionResponse } from "../../types/ApiResults";
import { BaseModelImpl } from "../../models/BaseModelImpl";
import { SystemEventDTO, SystemEventMetaDataDTO } from "./dto/SystemEventDTO";

export class SystemEvent extends BaseModelImpl<SystemEventDTO> {
    id: string;
    parentId: string;
    parentType: number;
    userId?: number;
    eventType: number;
    metaData?: SystemEventMetaDataDTO;
    createdAt: string;
    updatedAt: string;

    constructor(data?: SystemEventDTO) {
        super();
        this.assignData(data);
    }
}

export type SystemEventCollection = CollectionResponse<SystemEvent>;
